import { DuplicateIcon } from 'foundations-assets';
//@ts-expect-error FormattedDuration does not have a TS implementation.
import FormattedDuration from 'I18n/components/FormattedDuration';
import { Collapser } from 'foundations-components/transitional/components/Collapser';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { getClickToCopyTicketNumber } from '../constants/events';
import { Box } from 'foundations-components/transitional/components/Box';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const separatorDot = /*#__PURE__*/_jsx(Text, {
  as: "span",
  marginInline: "200",
  marginBlock: "0",
  children: '•'
});
const OpenTicketInformation = ({
  createDate
}) => {
  return /*#__PURE__*/_jsx("span", {
    style: {
      whiteSpace: 'nowrap'
    },
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "svh-workspace-ui-lib.ticket-header.openLabel",
      options: {
        duration: /*#__PURE__*/_jsx(FormattedDuration, {
          from: parseInt(createDate, 10),
          to: null
        })
      }
    })
  });
};
const ClosedTicketInformation = ({
  closeDate
}) => {
  return /*#__PURE__*/_jsxs("span", {
    style: {
      whiteSpace: 'nowrap'
    },
    children: [/*#__PURE__*/_jsx(Text, {
      as: "span",
      paddingInlineEnd: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-workspace-ui-lib.ticket-header.closedLabel"
      })
    }), /*#__PURE__*/_jsx(FormattedDateTime, {
      value: parseInt(closeDate, 10),
      format: "ll"
    })]
  });
};
const CollapsedInformation = ({
  createDate,
  closeDate
}) => {
  return /*#__PURE__*/_jsxs("span", {
    children: [separatorDot, closeDate ? /*#__PURE__*/_jsx(ClosedTicketInformation, {
      closeDate: closeDate
    }) : /*#__PURE__*/_jsx(OpenTicketInformation, {
      createDate: createDate
    })]
  });
};
const TicketInformation = ({
  ticketId,
  createDate,
  closeDate,
  trackEvent
}) => {
  return /*#__PURE__*/_jsx(Box, {
    inlineSize: "100%",
    children: /*#__PURE__*/_jsxs(Collapser, {
      fallback: /*#__PURE__*/_jsx(CollapsedInformation, {
        createDate: createDate,
        closeDate: closeDate
      }),
      children: [separatorDot, /*#__PURE__*/_jsx(CopyButton, {
        hint: () => /*#__PURE__*/_jsx(FormattedMessage, {
          message: "svh-workspace-ui-lib.ticket-header.copyButtonHint"
        }),
        hintSuccess: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "svh-workspace-ui-lib.ticket-header.copyButtonSuccess"
        }),
        tooltipPlacement: "right",
        use: "unstyled",
        value: ticketId,
        onClick: () => trackEvent(getClickToCopyTicketNumber()),
        children: /*#__PURE__*/_jsxs(Text, {
          color: "text-core-subtle",
          as: "span",
          children: [/*#__PURE__*/_jsx("span", {
            children: '#'
          }), /*#__PURE__*/_jsx("span", {
            children: ticketId
          }), /*#__PURE__*/_jsx(DuplicateIcon, {})]
        })
      }), /*#__PURE__*/_jsx(CollapsedInformation, {
        createDate: createDate,
        closeDate: closeDate
      })]
    })
  });
};
TicketInformation.displayName = 'TicketInformation';
CollapsedInformation.displayName = 'CollapsedInformation';
OpenTicketInformation.displayName = 'OpenTicketInformation';
ClosedTicketInformation.displayName = 'ClosedTicketInformation';
export default TicketInformation;